document.addEventListener('DOMContentLoaded', function () {
  const colectionSeoItems = document.querySelectorAll('.colection-seo__item');
  colectionSeoItems.forEach((item) => {
    item.addEventListener('click', function () {
      this.querySelector('.colection-seo__item__container').classList.toggle('active');
      this.querySelector('.colection-seo__item__description').classList.toggle('active');
      this.querySelector('.colection-seo__item__container svg').classList.toggle('rotate-180');
    });
  });
});
